import React, { forwardRef, ReactNode } from 'react';
import { OrderedList as ChakraList, ListProps } from '@chakra-ui/react';

interface Props extends ListProps {
  children: ReactNode;
}

export const OrderedList = forwardRef<HTMLOListElement, Props>(
  ({ children, ...props }, ref): JSX.Element => {
    return (
      <ChakraList
        ref={ref}
        stylePosition="inside"
        spacing={4}
        mb={4}
        {...props}
      >
        {children}
      </ChakraList>
    );
  }
);
export type { Props as OrderedListProps };
